import { get } from 'lodash';

import Model from 'models';
import Cloudinary from 'utils/Cloudinary';

const StoryModuleSlide = class extends Model {
  get buttonCTAs() {
    return get(this, ['_data', 'buttonCtAs'], []).map(buttonCta => {
      const { relativeUrl, ...rest } = buttonCta;

      return {
        linkUrl: relativeUrl,
        ...rest,
      };
    });
  }

  get desktopMedia() {
    const isVideoSlide =
      get(this, ['_data', 'desktopMedia', 'file', 'contentType']) === 'video/mp4';

    const desktopMedia = get(this, ['_data', 'desktopMedia']);

    if (isVideoSlide) {
      const poster = Cloudinary.generateVideoThumbnail(
        get(this, ['_data', 'desktopMedia', 'file', 'url']),
        {
          showOverlay: false,
        }
      );

      desktopMedia.file.poster = poster;
    }
    return desktopMedia;
  }

  get mobileMedia() {
    const isVideoSlide = get(this, ['_data', 'mobileMedia', 'file', 'contentType']) === 'video/mp4';

    const mobileMedia = get(this, ['_data', 'mobileMedia']);

    if (isVideoSlide) {
      const poster = Cloudinary.generateVideoThumbnail(
        get(this, ['_data', 'mobileMedia', 'file', 'url']),
        {
          showOverlay: false,
        }
      );

      mobileMedia.file.poster = poster;
    }
    return mobileMedia;
  }

  get subheader() {
    return get(this, ['_data', 'subheader']);
  }

  get supportingText() {
    return get(this, ['_data', 'supportingText']);
  }

  get internalName() {
    return get(this, ['_data', 'internalName']);
  }

  get eyebrow() {
    return get(this, ['_data', 'eyebrow']);
  }
};

export default StoryModuleSlide;
